<template>
    <div
        class="inline-flex items-center gap-0.5 rounded-xl bg-gray-100 p-1 ring-1 ring-inset ring-gray-200"
        role="group"
        aria-label="Language switcher"
    >
        <button
            v-for="locale in SUPPORTED_LOCALES"
            :key="locale"
            type="button"
            :aria-pressed="activeLocale === locale"
            :class="[
                'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold uppercase tracking-wide transition-all duration-200',
                activeLocale === locale
                    ? 'bg-white text-gray-800 shadow-sm ring-1 ring-inset ring-gray-200/60'
                    : 'text-gray-400 hover:text-gray-600',
            ]"
            @click="emit('update:activeLocale', locale)"
        >
            <span>{{ locale }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
import { SUPPORTED_LOCALES } from '@builder/defaults'

withDefaults(
    defineProps<{
        activeLocale?: (typeof SUPPORTED_LOCALES)[number]
    }>(),
    { activeLocale: SUPPORTED_LOCALES[0] }
)

const emit = defineEmits<{
    (e: 'update:activeLocale', value: (typeof SUPPORTED_LOCALES)[number]): void
}>()
</script>
